import { logger } from '@tuic/logger';

import { getUrlPageLocale } from '../../tracking/TrackingProvider';

import { getLooselyTypedUtag } from './tealium-helpers';

import type { EventData, PageViewData } from '../../tracking/tealium';

export const trackTealium = (
  data: PageViewData | EventData,
  as: 'Event' | 'Pageview',
) => {
  const tealiumEnv = process.env.NEXT_PUBLIC_TEALIUM_ENV_FLAG ?? 'prod';

  // Debug logging on local dev
  if (tealiumEnv === 'dev' || tealiumEnv === 'storybook') {
    logger.debug(
      `%c Tracking ${as}: `,
      'background: #800080; color: #ffccff',
      data,
    );
    return;
  }

  const utag = getLooselyTypedUtag(window);

  as === 'Event'
    ? utag.link({
        page_name: utag.data?.page_name,
        page_platform: utag.data?.page_platform,
        page_country: utag.data?.page_country || getUrlPageLocale(),
        page_language: utag.data?.page_language || getUrlPageLocale(),
        page_category: utag.data?.page_category,
        page_url_parameter: utag.data?.page_url_parameter,
        page_login_status: utag.data?.page_login_status,
        page_test_variant: utag.data?.page_test_variant,
        // page_native_app: utag.data?.page_native_app,
        page_region_code: utag.data?.page_region_code,
        page_route_recommendations: utag.data?.page_route_recommendations,
        // user_email_hashed: utag.data?.user_email_hashed,
        ...data,
      })
    : utag.view(data);
};
